/* eslint-disable no-unused-vars */
import { dataService } from "../services/data.services";
import { userService } from "../services/user.services";
import { setAuthItem, clearAuthSession, broadcastLogout } from "./authSession";


export const CheckUserStatus = async()=>{

    let user=true;

    //const user1 =  await userService.getUserData()
    try {
        const browserIdValue = localStorage.getItem('arcm_trust_browser_token');
        const user1 = await dataService.GetAPI('patients/check-status');
        setAuthItem('custom-status', user1?.data?.user_status);
        if (user1?.data?.data?.user_status==='inactive') {
            // User is deactivated, log out the user
            user=false;
            await userService.logout()
            clearAuthSession();
            broadcastLogout();
            localStorage.clear();
            localStorage.setItem('arcm_trust_browser_token', browserIdValue);
            window.location.reload()
        } 
    }catch (e) {
        //sessionStorage.setItem('custom-status', 'inactive');
        // await userService.logout()
        // localStorage.clear()
        // window.location.reload()
    }
    return user

}
   

        

    





